import { Injectable } from '@angular/core';
import { FilterModel } from 'src/app/shared/models/common-model';
import { CommonService } from 'src/app/shared/services/common.service';
@Injectable({
  providedIn: 'root'
})
export class ManageUserService {
  getAllURL = 'Hospital/all-users';
  getByIdURL = "Hospital/user-by-id";
  createURL = "Hospital/register-user";
  updateURL = "Hospital/user-update";
  deleteURL = "Hospital/user-delete";
  constructor(private commonService: CommonService) { }

  // getAll(filterModal: FilterModel) {
  //     let url = this.getAllURL + '?pageNumber=' + filterModal.pageNumber + '&pageSize=' + filterModal.pageSize + '&sortColumn=' + filterModal.sortColumn + '&sortOrder=' + filterModal.sortOrder + '&firstName=' + filterModal.searchText + '&email=' + filterModal.searchText;
  //     return this.commonService.getAll(url, {});
  // }
  getById(id: number) {
    return this.commonService.getById(this.getByIdURL + "?Id=" + id, {});
  }
  save(userModel: any) {
    return this.commonService.post(this.createURL, userModel);
  }

  update(userModel: any) {
    return this.commonService.put(this.updateURL, userModel);
  }

  delete(id: number) {
    return this.commonService.delete(`${this.deleteURL}?id=${id}`, {})
  }

  getAll(filterModal: FilterModel) {
    return this.commonService.getAll(this.getAllURL, filterModal.currentPage, filterModal.pageSize,
      filterModal.searchText, filterModal.sortOrder, filterModal.orderBy);
  }
}
